import { compileRoutes } from "@workflows/runtime-web";

export const routes = compileRoutes({
  "workflows.index": (_?: unknown) => "/workflows",
  "workflow.index": (_: { workflowId: string }) => "/workflows/:workflowId",
});
